/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext, useState, useEffect, useRef } from 'react';
import moment from 'moment';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import Grid from '@mui/material/Unstable_Grid2';
import { DatePicker } from '@mui/x-date-pickers';
import { toast } from 'react-toastify';
// CONTEXT
import AppConst from './AppLayout/const';
// API
import {
  getExportTemplate,
  getMonthlyAdminTagged,
  postImportMonthlyAdminTagged,
} from '../api/adminTaggedAccountApi';

export default function AdminTaggedAccounts() {
  const { toggleModal, onToggleModal } = useContext(AppConst.AppContext);
  const [toggle, setToggle] = useState(false);
  const [remarks, setRemarks] = useState({ toggle: false, message: '' });
  const [hasError, setHasError] = useState({ toggle: false, loading: false, errors: [] });

  const inputRef = useRef(null);

  const defaultFilter = {
    month_year: moment().format('YYYY-MM'),
    file: '',
    replace_current: false,
  };

  const [filterForm, setFilterForm] = useState(defaultFilter);

  const errorColumns = [{ field: 'error', headerName: 'Error Message', flex: 1 }];

  const handleMonthlyTaggedAccount = async (hasDate = false, dateValue = null) => {
    try {
      setRemarks({ ...remarks, toggle: false });
      toast.loading('Processing request please kindly wait...');
      const request = {
        month: Number(moment(hasDate ? dateValue : filterForm?.month_year).format('M')),
        year: Number(moment(hasDate ? dateValue : filterForm?.month_year).format('YYYY')),
      };

      const response = await getMonthlyAdminTagged(request);
      const { code, data } = response.data;

      if (code === '200') {
        setRemarks({ ...remarks, toggle: true, message: data });
      }
      toast.dismiss();
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  const handleChangeDate = (value) => {
    handleMonthlyTaggedAccount(true, value);
    setFilterForm({ ...filterForm, month_year: moment(value).format('YYYY-MM') });
  };

  const handleFileChange = (event) => {
    setFilterForm({ ...filterForm, file: event.target.files[0] });
  };

  const handleChangeFilter = (e, name) => {
    setFilterForm({
      ...filterForm,
      [name]: e.target.checked,
    });
  };

  const handleExportTemplate = async (current = false) => {
    try {
      toast.loading('Processing request please kindly wait...');
      const request = {
        month: current ? moment(filterForm?.month_year).format('M') : '',
        year: current ? moment(filterForm?.month_year).format('YYYY') : '',
      };

      const response = await getExportTemplate(request);
      const { code, result } = response.data;

      if (code !== '200') {
        toast.dismiss();
        toast.error('Error while exporting has been detected please kindly try again');
      }

      window.location.href = result;
      toast.dismiss();
      toast.success(`Exported successfully: ${response?.data?.file_name}`);
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };
  const handleCancel = () => {
    onToggleModal(null);
    setToggle(false);
  };

  const handleSubmit = async () => {
    try {
      toast.loading('Processing request please kindly wait...');
      const request = {
        month: Number(moment(filterForm?.month_year).format('M')),
        year: Number(moment(filterForm?.month_year).format('YYYY')),
        file: filterForm?.file,
        replace: filterForm?.replace_current ? 1 : 0,
      };

      const response = await postImportMonthlyAdminTagged(request);
      const { code, message } = response.data;

      if (code === '400') {
        toast.dismiss();
        const errorMEssages = response.data.error_message.map((row, i) => ({
          id: i,
          error: row,
        }));
        setHasError({ ...hasError, toggle: true, loading: false, errors: errorMEssages });
      }

      if (code === 200) {
        if (inputRef.current) {
          inputRef.current.value = '';
        }
        toast.dismiss();
        setHasError({ ...hasError, toggle: false, loading: false, errors: [] });
        toast.success(message);
        setFilterForm(defaultFilter);
        handleMonthlyTaggedAccount(true, filterForm?.month_year);
      }
    } catch (error) {
      toast.dismiss();
      toast.error(error.message);
    }
  };

  useEffect(() => {
    handleMonthlyTaggedAccount();
    if (toggleModal?.url === 'upload/tagged-accounts') {
      setToggle(true);
    }
    toast.dismiss();
  }, [toggleModal]);

  return (
    <Dialog open={toggle} onClose={() => handleCancel()} maxWidth='md' fullWidth>
      <DialogTitle>Account Tagging Maintenance</DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2} mb={1}>
          <Grid md={12} display='flex' justifyContent='flex-end' gap={1}>
            <Button variant='contained' color='warning' onClick={() => handleExportTemplate()}>
              Download Blank Template
            </Button>
            <Button variant='contained' color='warning' onClick={() => handleExportTemplate(true)}>
              Download Current
            </Button>
          </Grid>
          <Grid md={12}>
            <DatePicker
              label='month_year'
              views={['month', 'year']}
              value={filterForm?.month_year}
              // eslint-disable-next-line react/jsx-props-no-spreading
              renderInput={(params) => (
                <TextField {...params} label='Month Year' size='small' fullWidth />
              )}
              onChange={(value) => handleChangeDate(value)}
            />
          </Grid>
          <Grid md={12}>
            <TextField
              inputRef={inputRef}
              type='file'
              id='file'
              name='file'
              onChange={(e) => handleFileChange(e)}
              size='small'
              fullWidth
            />
            {remarks.toggle ? (
              <Typography variant='subtitle1' sx={{ color: '#e70606ff' }}>
                {remarks?.message}
              </Typography>
            ) : (
              ''
            )}
          </Grid>
          <Grid md={12}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={filterForm?.replace_current}
                  onChange={(e) => handleChangeFilter(e, 'replace_current')}
                />
              }
              label='Replace Current?'
            />
          </Grid>
          {hasError.toggle ? (
            <Grid md={12}>
              <div className='table-container' style={{ height: '400px', marginTop: '20px' }}>
                <DataGridPro
                  loading={hasError?.loading}
                  rows={hasError?.errors}
                  columns={errorColumns}
                  initialState={{
                    ...hasError?.errors.initialState,
                    pagination: { paginationModel: { pageSize: 50 } },
                  }}
                  pageSizeOptions={[25, 50, 75, 100]}
                  pagination
                />
              </div>
            </Grid>
          ) : (
            ''
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleSubmit()}>Submit</Button>
        <Button onClick={() => handleCancel()}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}
